import React from 'react';
import { Route, Switch } from 'react-router-dom';

import SettingsPublicDetails from './scenes/SettingsPublicDetails';
import SettingsCartAbandonment from './scenes/SettingsCartAbandonment';
import SettingsCustomerPortal from './scenes/SettingsCustomerPortal';
import SettingsDomains from './scenes/SettingsDomains';
import SettingsEmail from './scenes/SettingsEmail';
import SettingsGeneral from './scenes/SettingsGeneral/SettingsGeneral';
import SettingsIntegrations from './scenes/SettingsIntegrations';
import SettingsInvoices from './scenes/SettingsInvoices';
import SettingsMembers from './scenes/SettingsMembers';
import SettingsPayments from './scenes/SettingsPayments';
import SettingsStripe from './scenes/SettingsStripe';
import SettingsStripeTax from './scenes/SettingsStripeTax';
import SettingsApiKeys from './scenes/SettingsApiKeys/SettingsApiKeys';
import SettingsWebhooks from './scenes/SettingsWebhooks/SettingsWebhooks';

const Settings = () => {
  return (
    <Switch>
      <Route path="/settings/general" component={SettingsGeneral} />
      <Route path="/settings/public-details" component={SettingsPublicDetails} />
      <Route path="/settings/members" component={SettingsMembers} />
      <Route path="/settings/payments" component={SettingsPayments} />
      <Route path="/settings/cart-abandonment" component={SettingsCartAbandonment} />
      <Route path="/settings/invoices" component={SettingsInvoices} />
      <Route path="/settings/domains" component={SettingsDomains} />
      <Route path="/settings/email" component={SettingsEmail} />
      <Route path="/settings/customer-portal" component={SettingsCustomerPortal} />
      <Route path="/settings/integrations" component={SettingsIntegrations} />
      <Route path="/settings/stripe-tax" component={SettingsStripeTax} />
      <Route path="/settings/stripe" component={SettingsStripe} />
      <Route path="/settings/api" component={SettingsApiKeys} />
      <Route path="/settings/webhooks" component={SettingsWebhooks} />
    </Switch>
  );
};

export default Settings;
